import React from 'react';
import './BlogSection.css';
import img1 from '../components/assets/images/blog-1.jpg';
import img2 from '../components/assets/images/blog-2.jpg';
import img3 from '../components/assets/images/blog3.jpg';
import img4 from '../components/assets/images/blog-4.jpg';
import { Link } from 'react-router-dom';


const blogData = [
  {
    img: img1,
    date: 'June 30,2022',
    category: 'Shilajit',
    title: 'Top 10 Amazing Benefits Of Shilajit For Health',
  },
  {
    img: img2,
    date: 'April 02,2022',
    category: 'Shilajit',
    title: 'Top 5 Benefits of Shilajit In Summer',
  },
  {
    img: img3,
    date: 'Mar 09,2022',
    category: 'Desserts with Kesar',
    title: 'Summer Desserts with Kesar | Top 4 Kesar Desserts',
  },
  {
    img: img4,
    date: 'January 25,2022',
    category: 'Desserts with Kesar',
    title: 'Ashwagandha: An Ancient Herb for Treating Modern Concerns',
  },
];

const BlogSection = () => {
  return (
    <section className="blog-section">
      <div className="blog-header">
        <h2>
          LATEST <span className="verified">BLOG</span>
        </h2>
        <a><Link to="/blogSectionblog" className="all-blogs-link" >All Blogs &raquo;</Link></a>
      </div>
      <div className="blog-grid">
        {blogData.map((blog, index) => (
          <div className="blog-card" key={index}>
            <img src={blog.img} alt="blog" />
            <p className="blog-meta">
              {blog.date} – {blog.category}
            </p>
            <h3 className="blog-title">{blog.title}</h3>
            <a href="/blog" className="read-more">
              Read More &raquo;
            </a>
          </div>
        ))}
      </div>
 
    </section>
  );
};

export default BlogSection;
